import React, { useEffect, useState } from 'react';
import Button from './elements/Button';

const CookieConsentBanner = ({ initialPreferences, onSave }) => {
  const [analyticsUsageEnabled, setAnalyticsUsageEnabled] = useState(false);
  const [analyticsDeviceEnabled, setAnalyticsDeviceEnabled] = useState(false);

  useEffect(() => {
    setAnalyticsUsageEnabled(Boolean(initialPreferences?.analyticsUsage));
    setAnalyticsDeviceEnabled(Boolean(initialPreferences?.analyticsDevice));
  }, [initialPreferences]);

  const acceptNecessaryOnly = () => {
    onSave({ necessary: true, analyticsUsage: false, analyticsDevice: false });
  };

  const acceptSelected = () => {
    onSave({
      necessary: true,
      analyticsUsage: analyticsUsageEnabled,
      analyticsDevice: analyticsDeviceEnabled,
    });
  };

  const acceptAll = () => {
    onSave({ necessary: true, analyticsUsage: true, analyticsDevice: true });
  };

  return (
    <div className="fixed inset-0 z-[80] flex items-end justify-center bg-black/60 backdrop-blur-[1px] p-4 md:p-8">
      <div className="w-full max-w-6xl rounded-2xl border-2 border-accent-main bg-background-light shadow-[0_20px_60px_rgba(0,0,0,0.55)] p-5 md:p-7">
        <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
          <div className="text-left">
            <h3 className="text-lg md:text-2xl font-bold text-accent-main">Cookie Preferences</h3>
            <p className="text-sm md:text-base text-primary-dark mt-2">
              We use essential cookies to keep your account secure and the app functioning.
            </p>
            <p className="text-sm md:text-base text-primary-dark mt-1">
              Optional analytics cookies (Google Analytics&nbsp;4) help us understand how the app is used. Based on your selections, page-navigation and diagnostics data may be sent to Google LLC, USA.
            </p>
            <a href="/privacy" className="text-sm text-accent-main underline mt-2 inline-block font-medium">
              Read Privacy Policy
            </a>
            <div className="mt-4 rounded-lg border border-accent-main/40 bg-primary-light px-3 py-2 space-y-2">
              <label className="inline-flex items-center gap-3 text-sm md:text-base text-primary-dark">
                <input
                  type="checkbox"
                  checked={analyticsUsageEnabled}
                  onChange={(e) => setAnalyticsUsageEnabled(e.target.checked)}
                  className="h-5 w-5 accent-accent-main"
                />
                Usage analytics (page views and navigation patterns)
              </label>
              <label className="inline-flex items-center gap-3 text-sm md:text-base text-primary-dark">
                <input
                  type="checkbox"
                  checked={analyticsDeviceEnabled}
                  onChange={(e) => setAnalyticsDeviceEnabled(e.target.checked)}
                  className="h-5 w-5 accent-accent-main"
                />
                Device diagnostics (browser, platform, and viewport details)
              </label>
            </div>
          </div>

          <div className="flex flex-col gap-2 md:min-w-[240px]">
            <Button type="primary" onClick={acceptAll} className="w-full">
              Accept All
            </Button>
            <Button type="primary_outline" onClick={acceptSelected} className="w-full">
              Save Preferences
            </Button>
            <Button type="secondary_outline" onClick={acceptNecessaryOnly} className="w-full">
              Necessary Only
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
